import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import mrwilbroadpic from "./../assets/image/mrwilbroad.jpg";
import { Link } from "react-router-dom";
import EducationTimeline from "./EducationBackground";
import { motion } from "framer-motion";

const Introduction = () => {
  const RotationWords = [
    "Software Engineer",
    "Software Developer",
    "Web Developer",
    "Mobile Developer",
  ];
  const [loopNumber, setLoopNumber] = useState(0);
  const [DefaultText, setDefaultText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [Transitiontime, setTransitiontime] = useState(300 - Math.random() * 100);
  const period = 2000;

  useEffect(() => {
    const ticker = setInterval(() => {
      Tick();
    }, Transitiontime);

    return () => clearInterval(ticker);
  });

  const Tick = () => {
    let i = loopNumber % RotationWords.length;
    let fulltext = RotationWords[i];
    let UpdatedText = isDeleting
        ? fulltext.substring(0, DefaultText.length - 1)
        : fulltext.substring(0, DefaultText.length + 1);

    setDefaultText(UpdatedText);

    if (isDeleting) {
      setTransitiontime(prevTime => prevTime / 2);
    }

    if (!isDeleting && UpdatedText === fulltext) {
      setIsDeleting(true);
      setTransitiontime(period);
    } else if (isDeleting && UpdatedText === "") {
      setIsDeleting(false);
      setLoopNumber(loopNumber + 1);
      setTransitiontime(500);
    }
  };

  return (
      <Container fluid className="p-0 m-0 ">
        <Row className="g-0" style={{ minHeight: "100vh" }}>

          <Col
              md={6}
              className="d-flex flex-column justify-content-center align-items-center text-center p-4 position-relative"
              style={{
                minHeight: "100vh",
                backgroundImage: `url(${mrwilbroadpic})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
          >
            {/* Dark overlay */}
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"></div>

            {/* Content */}
            <div className="position-relative z-index-1 text-light">
              <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
              >
                <img
                    src={mrwilbroadpic}
                    alt="mrwilbroad"
                    className="rounded-circle mb-4 shadow"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      border: "4px solid rgba(255,255,255,0.2)"
                    }}
                />
                <h2 className="fw-bold">Hi, I'm mrwilbroad</h2>
                <h4 className="text-primary fw-semibold mb-4">
                  {DefaultText}
                  <motion.span
                      animate={{ opacity: [0, 1, 0] }}
                      transition={{ repeat: Infinity, duration: 1 }}
                      className="cursor"
                  >
                    |
                  </motion.span>
                </h4>

                <motion.div
                    className="mt-4 d-flex gap-3 justify-content-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                >
                  <Link to="mailto:info@ih-africa.com" className="btn btn-outline-light btn-lg">
                    <i className="fa-solid fa-envelope me-2"></i>Mail Me
                  </Link>
                  <Link
                      to="https://github.com/mrwilbroad"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light btn-lg"
                  >
                    <i className="fa-brands fa-github me-2"></i>Github
                  </Link>
                </motion.div>

                <motion.div
                    className="mt-5"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                >
                  <h5 className="mb-3 text-light">Find me</h5>
                  <div className="d-flex gap-3 justify-content-center mt-2 flex-wrap">
                    <SocialLink to="https://www.npmjs.com/~mrwilbroad" icon="fa-npm" />
                    <SocialLink to="https://bento.me/mrwilbroad" icon="fa-sliders" />
                    <SocialLink to="https://twitter.com/mrwilbroad" icon="fa-twitter" />
                    <SocialLink to="https://hashnode.com/@mrwilbroad" icon="fa-hashnode" />
                    <SocialLink to="https://www.linkedin.com/in/wilbroad-mark-395049243/" icon="fa-linkedin" />
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </Col>

          <Col
              md={6}
              className=" text-light p-4 md:mt-1"
          >

            <EducationTimeline />
          </Col>
        </Row>
      </Container>
  );
};

const SocialLink = ({ to, icon }: { to: string; icon: string }) => (
    <motion.div whileHover={{ y: -5 }}>
      <Link
          to={to}
          target="_blank"
          rel="noopener noreferrer"
          className="text-light border border-light rounded-circle p-3 d-flex align-items-center justify-content-center"
          title={to}
          style={{ width: "50px", height: "50px" }}
      >
        <i className={`fa-brands ${icon} fa-lg`}></i>
      </Link>
    </motion.div>
);

export default Introduction;